import { z } from 'zod';

export const teamSettingsSchema = z.object({
  teamName: z.object({
    id: z.string(),
    label: z.string(),
    value: z.string(),
  }),
  accountManager: z.object({
    id: z.string(),
    label: z.string(),
    value: z.string(),
  }),
  teamLead: z.object({
    id: z.string(),
    label: z.string(),
    value: z.string(),
  }),
  workHoursStart: z.string().min(1, 'Work hours start time is required'),
  workHoursEnd: z.string().min(1, 'Work hours end time is required'),
  teamMembers: z
    .array(
      z.object({
        id: z.string(),
        label: z.string(),
        value: z.string(),
      }),
    )
    .min(1, 'At least one team member is required'),
  checkInTimes: z
    .array(
      z.object({
        id: z.string().or(z.number()),
        label: z.string(),
        value: z.string(),
        time: z.string().optional(),
      }),
    )
    .min(2, 'Two check-in times are required'),
});

export type TeamSettingsFormData = z.infer<typeof teamSettingsSchema>;
